import React, { Component } from 'react';
import PropTypes from 'prop-types'
import * as types from '../../../constants/actionTypes';
import Drawer from '../../Common/Drawer/Drawer';
import Notification from '../../Common/Notification';
import MultiSelectBox from '../../Common/MultiSelectBox/MultiSelectBox';
import DatePicker from '../../Common/DatePicker/DatePicker';
import LoadingIndicator from '../../Common/LoadingIndicator/LoadingIndicator';
import Toggle from '../../Common/Toggle/Toggle';
import Button from '../../Common/Button';
import DaysOfWeekPicker from '../../Common/DaysOfWeekPicker/DaysOfWeekPicker';
import InputText from '../../Common/InputText';

export default class AddSingleLocProjectDrawer extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            project: {
                name: "",
                description: "",
                abbreviation: "",
                projectManagerId: "",
                baselineIds: [],
                supportAgentId: props.currentUserId,
                zeroDate: "",
                sendEmail: true,
                daysSelected: [0, 1, 2, 3, 4, 5, 6], //Sun - Sat
                locationKey: props.locationKey,
            },

            isFormValid: true,
            isSaving: false,
            isShowMoreOpen: false,
            filters: {
                projectManagers: [],
                baselines: [],
                supportAgents: []
            }
        };
    }

    componentDidMount = async () => {
        await this.loadFilters();
    }

    loadFilters = async () => {
        try {
            const response = await this.props.locationDashboardActions.loadSingleProjectDrawerFilters();
            if (response.type === types.LOAD_SINGLE_PROJECT_DRAWER_FILTERS_SUCCESS) {
                this.setState({
                    filters: { ...this.state.filters, ...response.payload }
                });
            } else if (response.type === types.LOAD_SINGLE_PROJECT_DRAWER_FILTERS_FAILURE) {
                Notification("error", "Error", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    formIsValid = () => {
        if (this.state.project.projectManagerId === "" || this.state.project.zeroDate === "" || this.state.project.zeroDate === "Invalid date" ||
            this.state.project.name.trim().length < 1 || this.state.project.abbreviation.trim().length < 1 || this.state.project.supportAgentId === "") {
            return false;
        } else {
            return true;
        }
    }

    onSaveClick = () => {
        // update isSaving immediately to remove Save button to prevent multiple api calls from double-clicks
        if (this.state.isSaving === false) {
            this.setState({ isSaving: true }, this.save);
        }
    }

    save = async () => {
        if (this.formIsValid()) {
            try {

                let project = this.state.project;
                const response = await this.props.locationDashboardActions.createSingleLocationProject(project);
                if (response.type === types.CREATE_SINGLE_LOCATION_PROJECT_SUCCESS) {
                    const { project } = response.payload;

                    Notification("success", "Success", "Single location project created successfully");
                    this.props.onComplete(project, this.state.project.baselineIds);
                } else if (response.type === types.CREATE_SINGLE_LOCATION_PROJECT_FAILURE) {
                    Notification("error", "An Error Occurred", response.payload.message);
                    this.setState({ isSaving: false });
                }
            } catch (error) {
                Notification("error", "Error", error);
                this.setState({ isSaving: false });
            }
        } else {
            this.setState({ isFormValid: false, isSaving: false });
        }

    }

    onSelectBoxChange = (id, name) => {
        this.setState({ project: { ...this.state.project, [name]: id } });
    }

    onBaselinesChange = (ids) => {
        this.setState({ project: { ...this.state.project, baselineIds: ids ? ids.split(",") : [] } });
    }

    onChangeZeroDate = (date) => {
        this.setState({ project: { ...this.state.project, zeroDate: date } });
    }

    onToggleEmailChange = () => {
        this.setState({ project: { ...this.state.project, sendEmail: !this.state.project.sendEmail } });
    }

    onToggleShowMore = () => {
        this.setState({ isShowMoreOpen: !this.state.isShowMoreOpen })
    }

    onInputChange = (e) => {
        this.setState({ project: { ...this.state.project, [e.target.name]: e.target.value } });
    }

    onDOWChange = (isChecked, value) => {
        let daysList = this.state.project.daysSelected;
        if (isChecked) {
            this.setState({
                project: {
                    ...this.state.project,
                    daysSelected: [...this.state.project.daysSelected, value]
                }
            })
        }
        else {
            const index = daysList.indexOf(value);
            if (index > -1) {
                daysList.splice(index, 1);
                this.setState({
                    project: {
                        ...this.state.project,
                        daysSelected: daysList
                    }
                })
            }
        }

    }

    render() {
        return (
            <div>
                <Drawer isWide={false}
                    title='Add Single Location Project'
                    onSaveClick={(this.state.isSaving) ? null : this.onSaveClick}
                    saveText="Save"
                    onCancelClick={this.props.onCancel}
                >
                    <LoadingIndicator isLoading={this.state.isSaving} >
                        <form noValidate className={this.state.isFormValid ? "" : "was-validated"} >
                            <InputText
                                name="name"
                                label="Project Name"
                                placeholder="Project Name"
                                type="text"
                                value={this.state.project.name}
                                onChange={this.onInputChange}
                                isRequired={true}
                                errorMessage="Project Name is required"
                                maxLength={100} />
                            <InputText
                                name="abbreviation"
                                label="Abbreviation"
                                placeholder="Abbreviation"
                                type="text"
                                value={this.state.project.abbreviation}
                                onChange={this.onInputChange}
                                isRequired={true}
                                errorMessage="Abbreviation is required" maxLength={100} />
                            <MultiSelectBox
                                name="baselineIds"
                                label="Baselines to Push (optional)"
                                idField="id"
                                valueField="name"
                                options={this.state.filters.baselines}
                                selectedValues={this.state.project.baselineIds.toString()}
                                onChange={this.onBaselinesChange}
                                isRequired={false}
                                isMulti={true}
                            />
                            <MultiSelectBox
                                name="projectManagerId"
                                label="Project Manager"
                                idField="id"
                                valueField="name"
                                options={this.state.filters.projectManagers}
                                selectedValues={this.state.project.projectManagerId.toString()}
                                onChange={this.onSelectBoxChange}
                                isRequired={true}
                                errorMessage="Project Manager is required"
                                isMulti={false}
                            />
                            <DatePicker
                                showIcon
                                value={this.state.project.zeroDate}
                                name="zeroDate"
                                label="Zero Date"
                                onChange={this.onChangeZeroDate}
                                isRequired={true}
                                errorMessage="Zero Date is required"
                            />

                            <Toggle name="sendEmail" text="Send Pushdown Notification Email" checked={this.state.project.sendEmail} onChange={this.onToggleEmailChange} />

                            {this.state.isShowMoreOpen ?
                                <div className='show-more-section mt-4'>
                                    <InputText
                                        name="description"
                                        label="Description"
                                        placeholder="Description"
                                        type="text"
                                        value={this.state.project.description}
                                        onChange={this.onInputChange}
                                        isRequired={false}
                                        maxLength={600} />

                                    <MultiSelectBox
                                        name="supportAgentId"
                                        label="Default Project Support Agent"
                                        idField="id" valueField="name"
                                        options={this.state.filters.supportAgents}
                                        onChange={this.onSelectBoxChange}
                                        selectedValues={this.state.project.supportAgentId.toString()}
                                        isRequired={true}
                                        errorMessage="Support Agent is required"
                                        isMulti={false}
                                    />

                                    {this.state.project.baselineIds.length > 0 &&
                                        <DaysOfWeekPicker
                                            onChange={this.onDOWChange}
                                            daysSelected={this.state.project.daysSelected}
                                            label="Select the days that apply to this project."
                                            errorMessage="At least one day of the week must be selected."
                                        />
                                    }

                                    <Button type="button" bootstrapClass="link" onClick={this.onToggleShowMore} text="Show Less" className='mt-3' />
                                </div>
                                :
                                <div>
                                    <Button type="button" bootstrapClass="link" onClick={this.onToggleShowMore} text="Show More" />
                                </div>
                            }
                        </form>
                    </LoadingIndicator>
                </Drawer>
            </div>
        )
    }
}

AddSingleLocProjectDrawer.propTypes = {
    locationDashboardActions: PropTypes.object.isRequired,
    locationKey: PropTypes.string.isRequired,
    onComplete: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    currentUserId: PropTypes.number.isRequired
};
